const observer = new MutationObserver(() => {
	const isotopeEllip = document.getElementById('usernameAndPassword_ellipsis');

	if (isotopeEllip !== null) {
		isotopeEllip.style.marginBottom = '0';

		const isotopeLogo = document.createElement('div');
		isotopeLogo.classList.add('mar-top--small', 'isotope-hidden--mobile');
		isotopeLogo.style.display = 'block';
		isotopeEllip.after(isotopeLogo);

		const isotopeWelcomeH1 = document.createElement('h1');

		isotopeWelcomeH1.classList.add('font-content-heading--district', 'mar-top--0', 'mar-bottom--big');
		isotopeWelcomeH1.innerText = Alkami.Localization.SiteText['UsernameAndPassword.Header'] || "Welcome to Online Banking";
		isotopeLogo.appendChild(isotopeWelcomeH1);

		observer.disconnect();
	}
});

observer.observe(document.body, {
	childList: true,
	subtree: true
});

